import { Injectable } from '@angular/core';
import { JSON } from 'ta-json';
import { StorageSelectors } from './storage.selectors';
import { StorageService } from './storage.service.interface';

/**
 * Provides function to save and load information
 * securely on local device.
 */
@Injectable()
export class StorageServiceImpl extends StorageService {
  /**
   * Reads from the secured storage.
   * If reading fails, returns null.
   */
  public readFromStorage<T>(selector: StorageSelectors): T {
    const raw = localStorage.getItem(selector);
    return JSON.deserialize<T>(JSON.parse(raw || '{}'));
  }

  /**
   * Writes to secured storage.
   */
  public setInStorage<T>(selector: StorageSelectors, value: T): void {
    const raw = JSON.stringify(value);
    localStorage.setItem(selector, raw);
  }

  /**
   * Removes stored object from secured storage.
   */
  public removeFromStorage(selector: StorageSelectors): void {
    localStorage.removeItem(selector);
  }

  /**
   * Removes everything from the storage
   */
  public clearStorage(): void {
    localStorage.clear();
  }
}
